import React from 'react';
import { ReactComponent as Edit } from '../../assets/images/icons/edit.svg';

export default function EditIcon(props) {
  return (
    <Edit {...props} className={'icon'} />
  );
}
